export default (node, handleVariantChange) => {
  const variants = JSON.parse(node.dataset.variants);
  const selectedId = node.dataset.selected;

  const handleChange = (event) => {
    // add selected variant id to the url without reloading the page
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.history.pushState({}, '', url);

    const selectedVariant = variants.find(
      (variant) => variant.id === event.target.value
    );

    if (!selectedVariant) return console.error('Selected variant not found');

    handleVariantChange(selectedVariant);

    // Emit event that the variant has changed
    document.dispatchEvent(
      new CustomEvent('variant:change', {
        detail: {
          variant: selectedVariant,
          productId: selectedVariant.product_id,
        },
      })
    );
  };

  node.addEventListener('change', handleChange);
};
